const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-white">
      
            <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">Terms and Conditions</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Please read these terms and conditions carefully before using our services.
          </p>
          <p className="text-sm text-gray-500 mt-4">Last updated: 9 June, 2025</p>
        </div>
      </section>


      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Products</h2>
              <p className="text-gray-600 mb-4">All our products are handmade resin artworks and custom-made as per individual requests.<br/>Due to the handmade nature, slight variations in color, shape, or finish may occur.<br/>Once an order is placed, it cannot be cancelled as we begin production based on your inputs.</p>
            </div>
<hr/>
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mt-5 mb-4">2. Shipping & Delivery</h2>
              <p className="text-gray-600 mb-4">Delivery timelines depend on the complexity of the design and your shipping location.<br/>Estimated delivery time will be communicated at order confirmation.</p>
            </div>
<hr/>
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mt-5 mb-4">3. Return & Refund Policy</h2>
              <p className="text-gray-600 mb-4">
We do not accept returns or exchanges as all items are made-to-order.<br/>Refunds are only applicable if the product is damaged during delivery (requires proof within 24 hours of receiving).
</p>
            </div>
<hr/>
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mt-5 mb-4">4. Customization</h2>
              <p className="text-gray-600 mb-4">Customers can chat directly with us and upload images or ideas for personalized orders.<br/>We are not liable for delays if incomplete or unclear information is shared from the customer's side.</p>
            </div>
<hr/>
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mt-5 mb-4">5.  Usage of Website Content</h2>
              <p className="text-gray-600 mb-4">All content, including photos, designs, and texts on this website, is the property of RangDesaaj.<br/>Do not reuse, reproduce, or copy our content without prior written permission.</p>
            </div>
<hr/>
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mt-5 mb-4">6. Agreement</h2>
              <p className="text-gray-600 mb-4">By using our site and placing an order, you agree to comply with these terms and acknowledge that you have read our Privacy Policy and Disclaimer..</p>
            </div>
<hr/>


            
            <div className="mb-12 mt-4">
              <div className="bg-gray-50 rounded-lg p-6">
             <h2 className="text-2xl font-bold text-gray-900 mt-4 mb-4">Thank you for choosing RangDesaaj – Crafted with Resin, Customized with Love.</h2>
              </div>
            </div>
          </div>
        </div>
      </section>



    </div>
  )
}

export default TermsAndConditions
